import { ChatContext } from '@/context/Chat';
import { Input } from 'antd';
import { useContext, useRef, useState } from 'react';
import ChatBox from '../components/ChatBox';
import { FullscreenOutlined, CloseOutlined } from '@ant-design/icons';
import { useSearchChatRooms } from '@/hooks/chat/useSearchChatRooms';
import Loader from '@/components/templates/Loader';
import { ChatListItem, getChatListItems } from '@/infrastructure/domain/chat';
import ChatItem from '../components/ChatItem';
import { useEntityNavigation } from '@/hooks/utils/useEntityNavigationLink';
import { useLoggedUser } from '@/hooks/user/useLoggedUser';

const ChatSideBar = () => {
  const { entityId, userType } = useLoggedUser();
  const {
    data: chatRooms,
    isLoading,
    isError,
  } = useSearchChatRooms(entityId, userType);

  const { navigateTo } = useEntityNavigation();
  const chatListItems = getChatListItems(chatRooms?.data, userType);
  const { isChatOpen, setIsChatOpen } = useContext(ChatContext);

  const [selectedChatRoom, setSelectedChatRoom] = useState<ChatListItem | null>(
    null,
  );
  const [showChatBox, setShowChatBox] = useState<boolean>(false);
  const chatRef = useRef<HTMLDivElement>(null);

  // FIXME: there is a bug when we click on the icon it flickers
  // useClickOutside(chatRef, () => setIsChatOpen(false));

  const handleFullScreen = () => {
    setIsChatOpen(false);
    setShowChatBox(false);
    navigateTo(`/chats`);
  };

  return isChatOpen ? (
    <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div
        ref={chatRef}
        className="fixed bottom-0 right-0 top-[69px] z-50 flex items-end"
      >
        {isLoading || isError ? (
          <Loader />
        ) : (
          <>
            {showChatBox && selectedChatRoom && (
              <ChatBox
                chatItem={selectedChatRoom}
                isModalView={true}
                showChatBox={setShowChatBox}
              />
            )}
            <div className="bg-white flex flex-col h-full shadow-lg w-[350px]">
              <div className="flex items-center justify-between p-4 ">
                <div className="flex items-center gap-2">
                  <h2 className="font-semibold">Chat</h2>
                  <FullscreenOutlined
                    className="hover:text-green-700 cursor-pointer"
                    onClick={handleFullScreen}
                  />
                </div>

                <div className="flex gap-2">
                  <CloseOutlined
                    className="hover:text-green-700 cursor-pointer"
                    onClick={() => setIsChatOpen(false)}
                  />
                </div>
              </div>

              <div className="p-4 border-b">
                <div className="relative">
                  <Input placeholder="Search in chat" className="pl-8 pr-8" />
                </div>
              </div>

              <div className="flex-1 overflow-auto">
                {chatListItems.map(chatRoom => (
                  <ChatItem
                    chatRoom={chatRoom}
                    isActive={selectedChatRoom?.id === chatRoom.id}
                    handleOnChatItemClick={() => {
                      if (!showChatBox) {
                        setShowChatBox(true);
                      }
                      setSelectedChatRoom(chatRoom);
                    }}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  ) : null;
};

export default ChatSideBar;
